export default {
  'nav.categories': 'Kategorie',
  'nav.home': 'Strona główna',
  'nav.shoppingGuide': 'Poradnik zakupowy',
  'nav.review': 'Recenzja',
  'nav.shipping': 'Wysyłka',
  'nav.safety': 'Bezpieczeństwo',
  'nav.buyNow': 'Kup teraz',
  'nav.language': 'Język',

  'footer.tagline': 'Niezależne źródło do wyszukiwania produktów, sprawdzania QC i mądrzejszych zakupów.',
  'footer.disclaimer': 'Ta strona jest niezależnym źródłem informacji i nie jest powiązana, wspierana ani sponsorowana przez USFans ani żadnego sprzedawcę. Zawsze weryfikuj informacje przed zamówieniem.',
  'footer.quickLinks': 'Szybkie linki',
  'footer.home': 'Strona główna',
  'footer.guide': 'Poradnik USFans Spreadsheet',
  'footer.categories': 'Kategorie',
  'footer.rights': 'Wszelkie prawa zastrzeżone.',
  'footer.language': 'Język',

  'cta.exploreSpreadsheet': 'Poznaj USFans Spreadsheet',
  'cta.buyNow': 'Kup teraz',
  'cta.startGuide': 'Zacznij od poradnika dla początkujących',
  'cta.browseCategories': 'Przeglądaj wszystkie kategorie',
  'cta.readGuide': 'Przeczytaj poradnik',
  'cta.readArticle': 'Przeczytaj poradnik',
  'cta.continueMain': 'Przejdź do głównej strony',
  'cta.readSafety': 'Przeczytaj poradnik bezpieczeństwa',
  'cta.backHome': 'Wróć na stronę główną',
};